module.exports = "/fonts/fa-brands-400.woff?2248542e1bbbd548a157e3e6ced054fc";